import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {EventBase} from "@synisys/idm-session-data-provider-api-js";
import {Observable} from "rxjs/Observable";
import {MetricsService} from "../service/api/metrics.service";

@Injectable()
export class ActiveUsersTrackInterceptor implements HttpInterceptor {

  constructor(private readonly eventBase: EventBase) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes("deservice") ||
      request.url.includes("entitysearchservice")) {
      this.eventBase.publish(MetricsService.USER_ACTIVITIES_EVENT, {
        area: "DATA_ENTRY"
      });
    }

    if (request.url.includes("reportingservice")) {
      this.eventBase.publish(MetricsService.USER_ACTIVITIES_EVENT, {
        area: "REPORTING"
      });
    }

    if ((request.method === "PUT" || request.method === "PATCH" || request.method === "DELETE") && (
      request.url.includes("kbservice") ||
      request.url.includes("wfservice") ||
      request.url.includes("eventhandlerservice") ||
      request.url.includes("umservice") ||
      request.url.includes("eventhandlerservice") ||
      request.url.includes("roleservice") ||
      request.url.includes("orgchartservice") ||
      (request.url.includes("notificationservice") && request.url.endsWith("/templates")) ||
      request.url.includes("formmanagementservice") ||
      request.url.includes("exporttemplateservice")
    )) {
      this.eventBase.publish(MetricsService.USER_ACTIVITIES_EVENT, {
        area: "ADMINISTRATION"
      });
    }

    if (request.url.includes("authservice") && request.url.includes("/token/prolong")) {
      this.eventBase.publish(MetricsService.SESSION_PROLONG_TIME_EVENT, {time: Date.now()});
    }

    return next.handle(request);
  }
}
